module.exports = __webpack_public_path__ + "img/ebook-shopping-mall-cover.d41d0c82.webp";